import type React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { createSearchString } from "../../../components/navigation/SearchString";
import type { AssetPosition } from "../../../kubb";
import type { Asset } from "../../../utils/object.tsx";
import AssetDataSelectionForm, {
  type AssetTimeSeriesRequestParams,
} from "./meters/AssetDataSelectionForm";

interface Props {
  device: Asset | AssetPosition;
  showProjection?: boolean;
  params: AssetTimeSeriesRequestParams;
}

export default function AssetDataSelectorUrlQuerySetter(
  props: Props,
): React.ReactElement {
  const { showProjection = true } = props;
  const initialValues = (): AssetTimeSeriesRequestParams => {
    const { start_datetime, end_datetime, projection } = props.params;
    return { start_datetime, end_datetime, projection };
  };
  const navigate = useNavigate();
  const location = useLocation();

  const selectData = (values: AssetTimeSeriesRequestParams): void => {
    const { projection, start_datetime, end_datetime } = values;
    navigate({
      search: createSearchString({
        start_datetime: start_datetime?.format(),
        end_datetime: end_datetime?.format(),
        projection: showProjection ? projection : undefined,
      }),
      hash: location.hash,
    });
  };

  return (
    <AssetDataSelectionForm
      {...initialValues()}
      device={props.device}
      loadData={selectData}
      showProjection={showProjection}
    />
  );
}
